import { BaseErrorParams, V8ErrorConstructor } from './types';

import _ from 'lodash';
import BaseError from './baseerror';

class AppError extends BaseError {
	constructor(
		{
			message,
			errorId,
			name = 'AppError',
			tag = '',
			originalError,
			errorDetails,
			details,
			visualisers,
			messageType,
			keepOriginalError
		}: BaseErrorParams) {

		super({message, errorId, name, tag, errorDetails, details, visualisers, messageType, keepOriginalError});
		Object.setPrototypeOf(this, AppError.prototype);
		if ('captureStackTrace' in Error) {
			(Error as V8ErrorConstructor).captureStackTrace(this, this.constructor);
		}

		originalError && this.processOriginalError(originalError);
	}
}

export default AppError;


// WEBPACK FOOTER //
// ./src/errors/apperror.ts